export const START_AUTH = 'START_AUTH'
export const GET_AUTH = 'GET_AUTH'
export const FAILED_AUTH = 'FAILED_AUTH'
export const DESTROY_AUTH = 'DESTROY_AUTH'
